import SpinnerIcon from "../../assets/icons/SpinnerIcon";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AlertOverlay from "../AlertOverlay";

const Dashboard = ({
  isFetchingResponse,
  isStopResponseAlertOverlayOpen,
  setIsStopResponseAlertOverlayOpen,
  stopFetchingResponse,
  infiniteScrollHeight,
  dashboardId,
  isLoading,
  dashboards,
}) => {
  const [activeDashboard, setActiveDashboard] = useState("");

  const navigate = useNavigate();

  return (
    <div
      style={{ height: infiniteScrollHeight - 100 }}
      className={`p-2 w-full text-xs cursor-pointer flex flex-col gap-2`}
    >
      {isLoading ? (
        <div className="h-[600px] flex justify-center items-center">
          <SpinnerIcon className="w-4 h-4 animate-spin" />
        </div>
      ) : (
        dashboards.map((dashboard) => {
          return (
            <div
              state={{ dashboardLabel: dashboard.label }}
              className={`group/item rounded-md relative p-2 hover:bg-zinc-800 opacity-80 ${
                activeDashboard === dashboard._id ||
                dashboard._id === dashboardId
                  ? "bg-zinc-800"
                  : ""
              } `}
              key={dashboard._id}
              onClick={() => {
                setActiveDashboard(dashboard._id);
                if (isFetchingResponse) {
                  setIsStopResponseAlertOverlayOpen(true);
                  return;
                }

                navigate(`dashboard/${dashboard._id}`);
              }}
            >
              <div className="whitespace-nowrap overflow-hidden text-zinc-100 ">
                {dashboard.label}
              </div>
              {activeDashboard !== dashboard._id &&
              dashboard._id !== dashboardId ? (
                <div className="absolute right-2 top-0 bg-gradient-to-l group-hover/item:invisible from-zinc-950 h-full w-12"></div>
              ) : null}
            </div>
          );
        })
      )}

      <AlertOverlay
        description={`Do you want to stop response for `}
        title="Stop Response?"
        primaryActionTitle="Cancel"
        secondaryActionTitle="Stop"
        isOpen={isStopResponseAlertOverlayOpen}
        onClick={async () => {
          await stopFetchingResponse();
          setIsStopResponseAlertOverlayOpen(false);
          navigate(`dashboard/${activeDashboard}`);
        }}
        setIsOpen={setIsStopResponseAlertOverlayOpen}
      />
    </div>
  );
};

export default Dashboard;
